module.exports = __webpack_public_path__ + "img/circle_yellow.f43a2735.svg";